import { buildMedicareMyPath } from './buildMedicareMyPath'

export const buildAbsoluteMedicareMyUrl = (path: string) => {
  return `${window.location.origin}${buildMedicareMyPath(path)}`
}
